import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTurkishairlinesComponent } from './simple-icons-turkishairlines.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTurkishairlinesComponent ],
    exports:      [ SimpleIconsTurkishairlinesComponent ],
    bootstrap:    []
})
export class SimpleIconsTurkishairlinesModule {}
